<template>
    <!--
    Gravatar group component
    Styled gravatar group component

    @property {Array} [emails]
    -->
    <figure class="gravatar-group">
        <img v-for="i in (Math.min(4, emails.length))" :src="getGravatar(emails[i - 1])" @load="imgLoaded">
    </figure>
</template>

<script>
import md5 from 'blueimp-md5';

export default
{
    name: 'GravatarGroup',

    props:
    {
        emails: '',
    },

    methods:
    {
        /**
         * Get the gravatar from provider
         *
         * @param {String} email
         * @returns {string}
         */
        getGravatar(email)
        {
            let user = email || '',
                hash = md5(user.trim().toLowerCase());

            return '//www.gravatar.com/avatar/' + hash + '?d=mm';
        },

        imgLoaded()
        {
            this.$emit('loaded', true);
        }
    },
}
</script>



// WEBPACK FOOTER //
// GravatarGroup.vue?f8e7785c